import React from 'react';
import clsx from 'clsx';
import {type UseFormReturn} from 'react-hook-form';
import {Typography} from '@mui/material';
import {composeClasses, styled, WithClasses} from '@netx/core-components/Theme';
import {type ICategoryCollisionFormValues} from '../../hooks';
import {CategoryCollisionManagerMessage} from '../../locales';
import {
	IOrganizeAssetsWarningObjectItem,
	IOrganizeAssetsWarningObjectItemAsset,
} from '../../schema';
import {CategoryCollisionItem} from './CategoryCollisionItem';
import {
	CATEGORY_COLLISION_MANAGER_NAME,
	categoryCollisionManagerClasses,
	type CategoryCollisionManagerClasses,
	getCategoryCollisionManagerUtilityClass,
} from './categoryCollisionManagerClasses';

type CategoryCollisionManagerOwnerState =
	WithClasses<CategoryCollisionManagerClasses>;

const useUtilityClasses = (ownerState: CategoryCollisionManagerOwnerState) => {
	const {classes} = ownerState;
	const slots = {
		root: ['root'],
	};
	return composeClasses(
		slots,
		getCategoryCollisionManagerUtilityClass,
		classes,
	);
};

const CategoryCollisionManagerRoot = styled('div', {
	name: CATEGORY_COLLISION_MANAGER_NAME,
	slot: 'Root',
	// overridesResolver: (props, styles) => [
	//     styles.root,
	// ],
})(({theme}) => ({}));

const CategoryCollisionManagerMessageWrapper = styled('div', {
	name: CATEGORY_COLLISION_MANAGER_NAME,
	slot: 'MessageWrapper',
})(({theme}) => ({
	marginBottom: theme.spacing(4),
}));

export interface CategoryCollisionManagerProps
	extends React.HTMLAttributes<HTMLDivElement>,
		WithClasses<CategoryCollisionManagerClasses> {
	form: UseFormReturn<ICategoryCollisionFormValues>;
	collision: Pick<IOrganizeAssetsWarningObjectItem, 'fileName'> & {
		asset: IOrganizeAssetsWarningObjectItemAsset;
		collision: IOrganizeAssetsWarningObjectItemAsset;
	};
}

export const CategoryCollisionManager = ({
	classes: _classes,
	className,
	collision,
}: CategoryCollisionManagerProps) => {
	const ownerState: CategoryCollisionManagerOwnerState = {
		classes: _classes,
	};

	const classes = useUtilityClasses(ownerState);

	return (
		<CategoryCollisionManagerRoot className={clsx(classes.root, className)}>
			<CategoryCollisionManagerMessageWrapper>
				<Typography>
					{CategoryCollisionManagerMessage.COLLISION_MESSAGE(
						collision.fileName,
					)}
				</Typography>
			</CategoryCollisionManagerMessageWrapper>
			<CategoryCollisionItem item={collision.collision} type="conflicting" />
			<CategoryCollisionItem item={collision.asset} type="incoming" />
		</CategoryCollisionManagerRoot>
	);
};
